import { ROUTES } from "navigation/routes";

export const NAVIGATE_LINKS = [
  { title: "Accounts", path: ROUTES.accounts },
  { title: "About Us", path: ROUTES.aboutUs },
  { title: "Blog", path: ROUTES.blogs },
  { title: "Contacts", path: ROUTES.contacts },
];
